import MonitoringTableFilters from './MonitoringTableFilters'

export default MonitoringTableFilters
